// extracted by mini-css-extract-plugin
module.exports = {"tabBox":"tabBox___2WNES","item_box":"item_box___16Ou5","item_content":"item_content___2knYj","item_title":"item_title___-IK5K","item_subtitle":"item_subtitle___1JE9d"};